import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({
        name: "",
        email: "",
        password: "",
        preferred_language: "english",
    });
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        const res = await register(form);
        setBusy(false);
        if (res.ok) navigate("/dashboard");
        else setErr(res.error);
    };

    const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    return (
        <div className="max-w-md mx-auto px-6 py-16">
            <div className="glass rounded-2xl p-8">
                <h1 className="font-heading text-3xl font-semibold tracking-tight mb-2">Create your account</h1>
                <p className="text-sm text-[var(--lt-muted)] mb-8">
                    Start your bilingual typing journey today.
                </p>
                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <label className="eyebrow block mb-2">Name</label>
                        <input
                            required
                            value={form.name}
                            onChange={set("name")}
                            className="w-full bg-[var(--lt-bg-2)] border border-[var(--lt-border)] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--lt-terracotta)]"
                            data-testid="register-name-input"
                            placeholder="Your name"
                        />
                    </div>
                    <div>
                        <label className="eyebrow block mb-2">Email</label>
                        <input
                            type="email"
                            required
                            value={form.email}
                            onChange={set("email")}
                            className="w-full bg-[var(--lt-bg-2)] border border-[var(--lt-border)] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--lt-terracotta)]"
                            data-testid="register-email-input"
                            placeholder="you@example.com"
                        />
                    </div>
                    <div>
                        <label className="eyebrow block mb-2">Password</label>
                        <input
                            type="password"
                            required
                            minLength={6}
                            value={form.password}
                            onChange={set("password")}
                            className="w-full bg-[var(--lt-bg-2)] border border-[var(--lt-border)] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--lt-terracotta)]"
                            data-testid="register-password-input"
                            placeholder="At least 6 characters"
                        />
                    </div>
                    <div>
                        <label className="eyebrow block mb-2">Preferred Language</label>
                        <div className="grid grid-cols-2 gap-2">
                            {["english", "nepali"].map((l) => (
                                <button
                                    type="button"
                                    key={l}
                                    onClick={() => setForm((f) => ({ ...f, preferred_language: l }))}
                                    className={`py-3 rounded-lg border transition-all ${
                                        form.preferred_language === l
                                            ? "border-[var(--lt-terracotta)] bg-[var(--lt-terracotta)]/10 text-[var(--lt-text)]"
                                            : "border-[var(--lt-border)] text-[var(--lt-muted)]"
                                    }`}
                                    data-testid={`register-lang-${l}`}
                                >
                                    {l === "english" ? "English" : "नेपाली"}
                                </button>
                            ))}
                        </div>
                    </div>
                    {err && (
                        <p className="text-sm text-red-400" data-testid="register-error">
                            {err}
                        </p>
                    )}
                    <button
                        type="submit"
                        disabled={busy}
                        className="btn-terra w-full disabled:opacity-60"
                        data-testid="register-submit-btn"
                    >
                        {busy ? "Creating…" : "Create Account"}
                    </button>
                </form>
                <p className="mt-6 text-sm text-[var(--lt-muted)] text-center">
                    Have an account?{" "}
                    <Link to="/login" className="text-[var(--lt-terracotta)] hover:underline">
                        Sign in
                    </Link>
                </p>
            </div>
        </div>
    );
}
